import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../../../services/auth.service";
import { gpcGoogleService } from "../../../../services/gpcGoogle.service";
import { AdministracionService } from "../../../../services/administracion.services";
import { Administracion } from "../../../../model/administracion.model";

@Component({
  selector: "app-my-account",
  templateUrl: "./my-account.component.html",
  styleUrls: ["./my-account.component.scss"],
})
export class MyAccountComponent implements OnInit {
  public userName!: string;
  public profileImg!: "assets/images/dashboard/profile.jpg";
  usuarioLogin: { id: number; username: string; email: string } | null = null;
  user$!: typeof this.authService.currentUser; // 👈 observable del usuario
  administraciones: Administracion[] = [];
  public logoUrl: string | null = null;

  constructor(
    public router: Router,
    private authService: AuthService,
    private gpcGoogle: gpcGoogleService,
     private administracionesServices: AdministracionService
  ) {

  }

  ngOnInit() {
   this.user$ = this.authService.currentUser;
 //  console.log(this.user$);
   this.cargarDataAdmin();
  

  // Opción B: acceder al valor actual
  //console.log('Valor actual:', this.authService.getCurrentUserValue());
  
  }

  logoutFunc() {
    this.authService.logout().subscribe({
      next: () => {
              this.router.navigateByUrl('auth/login');
      },
      error: () => {
        // Manejo de error opcional
        this.router.navigateByUrl('auth/login');
      }
    });
  }

  async getLogo(){
     
    const getSignedUrlSafe = async (path: string) => {
      try {
        const res = await this.gpcGoogle.getSignedUrl(path).toPromise();
        return res?.url || null;
      } catch {
        return null;
      }
    };
    
   
    // Si hay administraciones, obtener los logos de todas
    const signedUrls = await Promise.all(
      (this.administraciones || []).map(admin =>
        
        getSignedUrlSafe(`${admin.nit}/logos/logo.png`)
      )
     
    );

   // console.log(signedUrls);
      this.logoUrl = signedUrls.find(url => !!url) || null;
    // Ahora signedUrls es un array de URLs (o null si no existe)
  }

 private cargarDataAdmin():void{
      this.administracionesServices.obtenerTodas().subscribe({
          next: (data) => {
          // console.log(data);
              this.administraciones = data;       
              
           // console.log(this.administraciones[0].nit);
             this.getLogo();
          },
          error: (err) => {
            console.error("Error al cargar los conductores:", err);
          },
        });
 }

  
}
